import React from "react";
import project from "../images/project.png";
import "./styles.css";
import { Link } from "react-router-dom";
const Project = () => {
  return (
    <div className="section">
      <div className="row">
        <div className="col-xs-3" style={{ borderRadius: "50px!important" }}>
          <img
            src={project}
            alt="Project"
            style={{ borderRadius: "50%!important" }}
          />
        </div>
        <div className="col-xs-9">
          <div className="ptitle"> Projects</div>

          <div className="pbody">
            <p>
              pwa-prototype reporting, platform-reactjs migration, electronic
              voting using blockchain are some of my recent projects which
              involves the notable use of javascript and reactjs
            </p>
            
              <Link to="/projects/">
              <div className="pbottom"> Have a look at my projects</div>
              </Link>
            
          </div>
        </div>
      </div>
    </div>
  );
};
export default Project;
